import { render, staticRenderFns } from "./WxMsg.vue?vue&type=template&id=19d5c127&scoped=true&"
import script from "./WxMsg.vue?vue&type=script&lang=js&"
export * from "./WxMsg.vue?vue&type=script&lang=js&"
import style0 from "./WxMsg.vue?vue&type=style&index=0&id=19d5c127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d5c127",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d5c127')) {
      api.createRecord('19d5c127', component.options)
    } else {
      api.reload('19d5c127', component.options)
    }
    module.hot.accept("./WxMsg.vue?vue&type=template&id=19d5c127&scoped=true&", function () {
      api.rerender('19d5c127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxMsg.vue"
export default component.exports